import { render } from "./new_attachment_step.vue?vue&type=template&id=12241733"
import script from "./new_attachment_step.vue?vue&type=script&lang=js"
export * from "./new_attachment_step.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__